<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl text-bold">Module 6: Long-Term Goals</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Your long-term goals are three year mileposts on the journey to your Blue
      Sky Vision. I recommend you read chapter 5 of the book "Setting Long-term
      Goals" which is provided in the Download Assets area. The chapter not only
      defines Long-term goals, but it also takes you through how to set SMART
      goals. Then use the Blue Sky Vision Table you used in setting your Blue
      Sky Vision and focus on filling in the Long-term Goals column which is
      column D.
    </p>
    <p class="mt-6 text-lg">
      By going through this module, you will better understand what Long-term
      Goals are, why they are Important, and the steps you need to follow to
      create your own. I take you through the Flint Inc. example and then you
      "Do The Work" and set your Long-term Goals which you then enter online
      into your One Page Alignment Plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832295"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-2xl font-bold">6.2 What are they?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you the definition of long-term goals.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832300"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-2xl font-bold">6.3 Why are they important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you why long-term goals are important for you, your team, and
      your company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832307"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-2xl font-bold">6.4 How to Develop?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I walk you through how to create three to five long-term goals using the
      Blue Sky Vision table that already has columns A and E already filled in.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832314"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-2xl font-bold">6.5 Flint Inc.</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. followed the process to
      develop a set of Long-term goals for his company.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832323"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-2xl font-bold">6.6 Do the Work</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This video is a brief overview of the process you will follow to develop a
      set of long-term goals for your company.
    </p>

    <p class="mt-6 text-lg">You Can Do This!!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832328"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-2xl font-bold">6.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the Long-term Goals module. I end
      the video by giving you a brief overview of the Annual Goals module which
      is next.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284832337"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
